// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ValueSection_value-section__G7bme {
  padding: 56px 20px;
  padding-bottom: 0px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
@media (min-width: 720px) {
  .ValueSection_value-section__G7bme {
    padding: 0px 40px;
  }
}

.ValueSection_container__iYGBQ {
  max-width: 1240px;
  margin: 0 auto;
  padding: 56px 0px;
  border-radius: 24px;
}

.ValueSection_header__YQc-6 {
  text-align: center;
  max-width: 860px;
  margin: 0 auto 32px;
}

.ValueSection_eyebrow__MEMqe {
  margin: 0 0 16px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #82B194;
  text-transform: uppercase;
}

.ValueSection_title__J93hE {
  margin: 0 0 36px;
  font-size: 32px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #13231D;
}
@media (min-width: 821px) {
  .ValueSection_title__J93hE {
    font-size: 42px;
  }
}

.ValueSection_subtitle__QAfU4 {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #5F726B;
  font-weight: 400;
}
@media (min-width: 821px) {
  .ValueSection_subtitle__QAfU4 {
    font-size: 17px;
  }
}

.ValueSection_collage-container__pBYja {
  margin-bottom: 56px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.ValueSection_collage-image__WoKGm {
  width: 1200px;
  height: auto;
  object-fit: cover;
}

.ValueSection_cards-grid__gr9cB {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
  margin: 0 auto;
  max-width: 1160px;
}
@media (min-width: 576px) {
  .ValueSection_cards-grid__gr9cB {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 900px) {
  .ValueSection_cards-grid__gr9cB {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 1200px) {
  .ValueSection_cards-grid__gr9cB {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 14px;
  }
}

.ValueSection_card__HYd-q {
  background: #F7F5F1;
  border-radius: 20px;
  padding: 16px 16px 15px;
  display: grid;
  gap: 8px;
  box-shadow: 0 16px 38px rgba(18, 34, 29, 0.04);
}

.ValueSection_card-title__K-DGJ {
  margin: 0;
  font-size: 16.5px;
  font-weight: 800;
  color: #13231D;
  line-height: 1.18;
  letter-spacing: -0.025em;
}

.ValueSection_card-desc__LfhrG {
  margin: 0;
  font-size: 13.25px;
  line-height: 1.52;
  color: #5F726B;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/ValueSection/ValueSection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,kBAAA;EACA,mBAAA;EACA,oFDCU;ACgBZ;AAfE;EALF;IAMI,iBAAA;EAkBF;AACF;;AAfA;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAkBF;;AAfA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;AAkBF;;AAfA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAkBF;AAhBE;EARF;IASI,eAAA;EAmBF;AACF;;AAhBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAmBF;AAhBE;EARF;IASI,eAAA;EAmBF;AACF;;AAhBA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;AAmBF;AAjBE;EAPF;IAQI,qCAAA;EAoBF;AACF;AAlBE;EAXF;IAYI,qCAAA;EAqBF;AACF;AAnBE;EAfF;IAgBI,gDAAA;IACA,SAAA;EAsBF;AACF;;AAnBA;EACE,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;EACA,8CAAA;AAsBF;;AAnBA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,wBAAA;AAsBF;;AAnBA;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAsBF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.value-section {\n  padding: 56px 20px;\n  padding-bottom: 0px;\n  font-family: $font-main;\n\n  @media (min-width: 720px) {\n    padding: 0px 40px;\n  }\n}\n\n.container {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 56px 0px;\n  border-radius: 24px;\n}\n\n.header {\n  text-align: center;\n  max-width: 860px;\n  margin: 0 auto 32px;\n}\n\n.eyebrow {\n  margin: 0 0 16px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #82B194;\n  text-transform: uppercase;\n}\n\n.title {\n  margin: 0 0 36px;\n  font-size: 32px;\n  line-height: 1.1;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #13231D;\n\n  @media (min-width: 821px) {\n    font-size: 42px;\n  }\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #5F726B;\n  font-weight: 400;\n\n\n  @media (min-width: 821px) {\n    font-size: 17px;\n  }\n}\n\n.collage-container {\n  margin-bottom: 56px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.collage-image {\n  width: 1200px;\n  height: auto;\n  object-fit: cover;\n}\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 16px;\n  margin: 0 auto;\n  max-width: 1160px;\n\n  @media (min-width: 576px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media (min-width: 900px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 14px;\n  }\n}\n\n.card {\n  background: #F7F5F1;\n  border-radius: 20px;\n  padding: 16px 16px 15px;\n  display: grid;\n  gap: 8px;\n  box-shadow: 0 16px 38px rgba(18, 34, 29, .04);\n}\n\n.card-title {\n  margin: 0;\n  font-size: 16.5px;\n  font-weight: 800;\n  color: #13231D;\n  line-height: 1.18;\n  letter-spacing: -0.025em;\n}\n\n.card-desc {\n  margin: 0;\n  font-size: 13.25px;\n  line-height: 1.52;\n  color: #5F726B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"value-section": `ValueSection_value-section__G7bme`,
	"container": `ValueSection_container__iYGBQ`,
	"header": `ValueSection_header__YQc-6`,
	"eyebrow": `ValueSection_eyebrow__MEMqe`,
	"title": `ValueSection_title__J93hE`,
	"subtitle": `ValueSection_subtitle__QAfU4`,
	"collage-container": `ValueSection_collage-container__pBYja`,
	"collage-image": `ValueSection_collage-image__WoKGm`,
	"cards-grid": `ValueSection_cards-grid__gr9cB`,
	"card": `ValueSection_card__HYd-q`,
	"card-title": `ValueSection_card-title__K-DGJ`,
	"card-desc": `ValueSection_card-desc__LfhrG`
};
export default ___CSS_LOADER_EXPORT___;
